/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { MotionArgs, Waypoint } from "../../waypoints";

export const protobufPackage = "skills";

export interface WingWaypoint {
  waypoint: Waypoint | undefined;
  motionArgs: MotionArgs | undefined;
}

export interface WingWaypointsCommandActionArgs {
  waypoints: WingWaypoint[];
  startFromVehiclePose: boolean;
}

export interface WingWaypointsCommandResultData {
}

export interface WingWaypointsCommandActionStateData {
}

function createBaseWingWaypoint(): WingWaypoint {
  return { waypoint: undefined, motionArgs: undefined };
}

export const WingWaypoint = {
  encode(message: WingWaypoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.waypoint !== undefined) {
      Waypoint.encode(message.waypoint, writer.uint32(10).fork()).ldelim();
    }
    if (message.motionArgs !== undefined) {
      MotionArgs.encode(message.motionArgs, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WingWaypoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWingWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.waypoint = Waypoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.motionArgs = MotionArgs.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WingWaypoint {
    return {
      waypoint: isSet(object.waypoint) ? Waypoint.fromJSON(object.waypoint) : undefined,
      motionArgs: isSet(object.motionArgs) ? MotionArgs.fromJSON(object.motionArgs) : undefined,
    };
  },

  toJSON(message: WingWaypoint): unknown {
    const obj: any = {};
    if (message.waypoint !== undefined) {
      obj.waypoint = Waypoint.toJSON(message.waypoint);
    }
    if (message.motionArgs !== undefined) {
      obj.motionArgs = MotionArgs.toJSON(message.motionArgs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WingWaypoint>, I>>(base?: I): WingWaypoint {
    return WingWaypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WingWaypoint>, I>>(object: I): WingWaypoint {
    const message = createBaseWingWaypoint();
    message.waypoint = (object.waypoint !== undefined && object.waypoint !== null)
      ? Waypoint.fromPartial(object.waypoint)
      : undefined;
    message.motionArgs = (object.motionArgs !== undefined && object.motionArgs !== null)
      ? MotionArgs.fromPartial(object.motionArgs)
      : undefined;
    return message;
  },
};

function createBaseWingWaypointsCommandActionArgs(): WingWaypointsCommandActionArgs {
  return { waypoints: [], startFromVehiclePose: false };
}

export const WingWaypointsCommandActionArgs = {
  encode(message: WingWaypointsCommandActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.waypoints) {
      WingWaypoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.startFromVehiclePose === true) {
      writer.uint32(16).bool(message.startFromVehiclePose);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WingWaypointsCommandActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWingWaypointsCommandActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.waypoints.push(WingWaypoint.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.startFromVehiclePose = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WingWaypointsCommandActionArgs {
    return {
      waypoints: globalThis.Array.isArray(object?.waypoints)
        ? object.waypoints.map((e: any) => WingWaypoint.fromJSON(e))
        : [],
      startFromVehiclePose: isSet(object.startFromVehiclePose)
        ? globalThis.Boolean(object.startFromVehiclePose)
        : false,
    };
  },

  toJSON(message: WingWaypointsCommandActionArgs): unknown {
    const obj: any = {};
    if (message.waypoints?.length) {
      obj.waypoints = message.waypoints.map((e) => WingWaypoint.toJSON(e));
    }
    if (message.startFromVehiclePose === true) {
      obj.startFromVehiclePose = message.startFromVehiclePose;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WingWaypointsCommandActionArgs>, I>>(base?: I): WingWaypointsCommandActionArgs {
    return WingWaypointsCommandActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WingWaypointsCommandActionArgs>, I>>(
    object: I,
  ): WingWaypointsCommandActionArgs {
    const message = createBaseWingWaypointsCommandActionArgs();
    message.waypoints = object.waypoints?.map((e) => WingWaypoint.fromPartial(e)) || [];
    message.startFromVehiclePose = object.startFromVehiclePose ?? false;
    return message;
  },
};

function createBaseWingWaypointsCommandResultData(): WingWaypointsCommandResultData {
  return {};
}

export const WingWaypointsCommandResultData = {
  encode(_: WingWaypointsCommandResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WingWaypointsCommandResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWingWaypointsCommandResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WingWaypointsCommandResultData {
    return {};
  },

  toJSON(_: WingWaypointsCommandResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WingWaypointsCommandResultData>, I>>(base?: I): WingWaypointsCommandResultData {
    return WingWaypointsCommandResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WingWaypointsCommandResultData>, I>>(_: I): WingWaypointsCommandResultData {
    const message = createBaseWingWaypointsCommandResultData();
    return message;
  },
};

function createBaseWingWaypointsCommandActionStateData(): WingWaypointsCommandActionStateData {
  return {};
}

export const WingWaypointsCommandActionStateData = {
  encode(_: WingWaypointsCommandActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WingWaypointsCommandActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWingWaypointsCommandActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WingWaypointsCommandActionStateData {
    return {};
  },

  toJSON(_: WingWaypointsCommandActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WingWaypointsCommandActionStateData>, I>>(
    base?: I,
  ): WingWaypointsCommandActionStateData {
    return WingWaypointsCommandActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WingWaypointsCommandActionStateData>, I>>(
    _: I,
  ): WingWaypointsCommandActionStateData {
    const message = createBaseWingWaypointsCommandActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
